import React from "react";
import DataTable from "react-data-table-component-with-filter";
import {
  DATE_FORMAT_CLIENT,
  customDataTableStyles,
  defaultPageLimit,
  defaultRowsPerPageOptions,
} from "../../Helper/Constants";
import ReactDatePicker from "react-datepicker";
import { Tooltip } from "react-tooltip";
import GetSvgIcon, { GetSvgTruck } from "../../../images/svglist";
import { getUserInfo } from "../../AuthUtils/AuthUtils";
import {
  CHARTERED_RATE_WEIGHT_ID,
  CNCL_ORD_STS,
  DLV_ORD_STS,
  LINEHAUL_ADMIN_USER_TYPE,
  LINEHAUL_CUSTOMER_USER_TYPE_LIST,
  LINEHAUL_STAFF_USER_TYPE,
  ORD_STS,
  ORDER_TYPE,
  PLAN_STATUS_REACHED,
  PLAN_STATUS_SCHEDULE,
  PLC_ORD_STS,
  PND_PYMT_ORD_STS,
  SCHCHRATECONFIG,
  SCHCHROUTESCHEDULE,
  TRANSIT_ORD_STS,
} from "../../../ConfigConstants/ConfigConstants";
import {
  getOrderStatusBadgeClass,
  permissionCheck,
} from "../../Helper/CommonMethods";
import moment from "moment";
import { OverlayTrigger, Popover } from "react-bootstrap";

const invalidDataArr = [null, undefined, "", "null", "undefined"];

const ScheduleList = ({
  scheduleList,
  onSubmit,
  searchParams,
  handleChange,
  openRouteDetls,
  handleBtnClick,
  openModalForWgt,
  openChartRateConfig,
  openAddTruckConfig,
  unassignTrip,
  openChOrdDetails,
}) => {
  const userType = getUserInfo("userType");
  const BookBtn = ({ row }) => (
    <>
      <div
        data-tooltip-id={"plan-" + row?.planId}
        // onClick={() => handlePlanBtnClick(row)}
        onClick={() => handleBtnClick(row)}
        className="theme-violet-txt"
      >
        <span className="text-success">Confirm {GetSvgIcon("IconTruck")}</span>
      </div>
      <Tooltip
        id={"plan-" + row?.planId}
        content={"Chartered Booking"}
        place="left"
      />
    </>
  );

  const AddWeightBtn = ({ row }) => {
    const isOrdConfirm = row?.isConfirm;
    return (
      <>
        {!isOrdConfirm && (
          <>
            <div
              data-tooltip-id={"plan-" + row?.planId}
              onClick={() => {
                document.body.click();
                openModalForWgt(row);
              }}
              className="theme-violet-txt action-item-button"
            >
              {GetSvgIcon("BasketFill")} Add Weight
            </div>
            <Tooltip
              id={"plan-" + row?.planId}
              content={"Add Weight"}
              place="left"
            />
          </>
        )}
      </>
    );
  };

  //Add Truck Button
  const AddTruckBtn = ({ row }) => {
    return (
      <>
        {[LINEHAUL_ADMIN_USER_TYPE, LINEHAUL_STAFF_USER_TYPE].includes(
          userType
        ) &&
          row.isTruckAdded === false &&
          row.isSecondary === false && (
            <>
              <div
                data-tooltip-id={"add-plan-" + row?.planId}
                onClick={() => {
                  document.body.click();
                  openRouteDetls(row, "A");
                }}
                className="theme-violet-txt ps-2 action-item-button"
              >
                {GetSvgTruck(row)} Add Truck
              </div>
              <Tooltip
                id={"add-plan-" + row?.planId}
                content={"Add Truck"}
                place="left"
              />
            </>
          )}
      </>
    );
  };

  const callForConditions = (row) => {
    const conditionArr = [
      row?.orderType === ORDER_TYPE.CHA &&
        permissionCheck(SCHCHRATECONFIG, "allowedWrite") &&
        row?.ordStatus === ORD_STS.AWAIT_RATE_INFO,
      [LINEHAUL_ADMIN_USER_TYPE, LINEHAUL_STAFF_USER_TYPE].includes(userType) &&
        row?.status !== PLAN_STATUS_REACHED &&
        [
          ORD_STS.AWAIT_QTY_INFO,
          ORD_STS.AWAIT_QTY_CFM,
          PLC_ORD_STS,
          TRANSIT_ORD_STS,
        ].includes(row?.ordStatus),
      // row?.status !== PLAN_STATUS_REACHED &&
      // ![DLV_ORD_STS, CNCL_ORD_STS, PND_PYMT_ORD_STS].includes(row?.ordStatus),
    ];

    return conditionArr;
  };

  const ConditionalBtn = ({ row }) => {
    let btnHtml = [];
    const today = moment().startOf("day");
    const isPlanInPast = moment(
      row?.tripStart,
      "DD-MM-YYYY HH:mm",
      true
    ).isAfter(today);
    // if (
    //   LINEHAUL_CUSTOMER_USER_TYPE_LIST.includes(userType) &&
    //   !!row.rateCode &&
    //   !row.order_id &&
    //   row?.status === 572 &&
    //   isPlanInPast
    // ) {
    //   btnHtml.push(<BookBtn row={row} />);
    // }

    // if (
    //   [LINEHAUL_ADMIN_USER_TYPE, LINEHAUL_STAFF_USER_TYPE].includes(userType) &&
    //   row.rateType === CHARTERED_RATE_WEIGHT_ID &&
    //   row?.status !== 574
    // ) {
    //   btnHtml.push(<AddWeightBtn row={row} />);
    // }
    const conditionArr = callForConditions(row);
    if (conditionArr[0]) {
      btnHtml.push(<RateConfigBtn data={row} />);
    }

    if (conditionArr[1]) {
      btnHtml.push(<RouteCodeBtn data={row} />);
    }

    return btnHtml;
  };

  const RouteCodeBtn = ({ data }) => {
    let retHtml = <></>;
    if (permissionCheck(SCHCHROUTESCHEDULE, "allowedWrite")) {
      retHtml = (
        <>
          <div
            onClick={() => {
              document.body.click();
              openRouteDetls(data, "E");
            }}
            className="action-item-button" //"modal-links fw-bold"
          >
            {/* {data?.routeCode || <span className="fw-bold">No Route Code</span>} */}
            {GetSvgIcon("VehicleTruck")} Trip Plan
          </div>

          {!data?.actualStart && !!data?.driver1 && (
            <div
              className="action-item-button"
              onClick={() => {
                unassignTrip(data);
                document.body.click();
              }}
            >
              {GetSvgIcon("Geoalttrack")} UnAssign Trip
            </div>
          )}
        </>
      );
    } else {
      // retHtml = <span className="fw-bold">{data?.routeCode}</span>;
    }
    return retHtml;
  };

  const RateConfigBtn = ({ data }) => {
    return (
      <div
        className="action-item-button"
        onClick={() => {
          document.body.click();
          openChartRateConfig(data);
        }}
      >
        {GetSvgIcon("IconCoin")} Configure Rate
      </div>
    );
  };

  const getFullAddress = (row, type) => {
    const isOrigin = type === "orgAddr";
    const Addr = isOrigin ? row?.orgAddr : row?.destAddr;
    const City = isOrigin ? row?.orgCity : row?.destCity;
    const State = isOrigin ? row?.orgState : row?.destState;
    const Postcode = isOrigin ? row?.orgPostCode : row?.destPostCode;

    return `Address: ${Addr}\ncity: ${City}\nstate: ${State}\nPostCode: ${Postcode}`;
  };

  const columns = [
    {
      name: "Customer",
      selector: (row) =>
        invalidDataArr.includes(row?.bussName)
          ? `${row?.custName} (${row?.acctCode})`
          : `${row?.bussName} (${row?.acctCode})`,
      sortable: true,
      filterable: true,
    },
    {
      name: "Order No",
      selector: (row) => row?.orderNo,
      cell: (row) => (
        <>
          <div
            onClick={() => openChOrdDetails(row)}
            className="modal-links fw-bold"
          >
            {row.orderNo}
          </div>
        </>
      ),
      sortable: true,
      filterable: true,
    },
    {
      name: "Route Code",
      selector: (row) =>
        row?.orderType === ORDER_TYPE.CHP ? row?.routeCode : "On-Demand",
      cell: (row) =>
        row?.orderType === ORDER_TYPE.CHP ? row?.routeCode : "On-Demand",
      sortable: true,
      filterable: true,
    },
    {
      name: "Origin",
      sortable: true,
      filterable: true,
      cell: (row) => (
        <>
          <pre className="box-text">
            <span className="d-inline-block">
              {getFullAddress(row, "orgAddr")}
            </span>
          </pre>
        </>
      ),
      width: "150px",
    },
    {
      name: "Destination",
      sortable: true,
      filterable: true,
      cell: (row) => (
        <>
          <pre className="box-text">
            <span className="d-inline-block">
              {getFullAddress(row, "destAddr")}
            </span>
          </pre>
        </>
      ),
      width: "150px",
    },
    {
      name: "Stops",
      selector: (row) => JSON.parse(row?.stops).length,
      sortable: true,
      filterable: true,
      width: "90px",
    },
    // Dt. 01/12/2025: CJ told to hide trip date
    // {
    //   name: "Trip Date",
    //   selector: (row) =>
    //     moment(row?.tripStart, "DD-MM-YYYY HH:mm").format("DD-MM-YYYY"),
    //   sortable: true,
    //   filterable: true,
    // },
    {
      name: "Pickup Date",
      // Dt. 01/12/2025: CJ told to show pickup date (given during booking)
      // instead of actual start date
      selector: (row) =>
        moment(row.shipDate, "YYYY-MM-DD").format("DD-MM-YYYY"),
      sortable: true,
      filterable: true,
    },
    {
      name: "Delivery Date",
      selector: (row) =>
        moment(row?.estDelivery, "YYYY-MM-DD").format("DD-MM-YYYY"),
      sortable: true,
      filterable: true,
    },

    // {
    //   name: "Dedicated To",
    //   selector: (row) => row?.acctCode,
    //   sortable: true,
    //   filterable: true,
    // },

    {
      name: "Rate Type",
      selector: (row) => row?.rateTypeTxt,
      sortable: true,
      filterable: true,
    },
    // {
    //   name: "Vehicle Type (Ton)",
    //   selector: (row) =>
    //     row?.vhclType + (!!row?.vhclWeight ? ` (${row?.vhclWeight})` : ""),
    //   sortable: true,
    //   filterable: true,
    // },
    {
      name: "Vehicle Number",
      selector: (row) => row?.vhclNo,
      sortable: true,
      filterable: true,
    },
    // {
    //   name: "Weight",
    //   selector: (row) =>
    //     row.rateType === CHARTERED_RATE_WEIGHT_ID &&
    //     !!row.serviceValue &&
    //     +row.serviceValue > 0
    //       ? row.serviceValue
    //       : "N/A",
    //   sortable: true,
    //   filterable: true,
    // },
    // {
    //   name: "Man Power",
    //   selector: (row) =>
    //     !!row.manpowerSvcVal && +row.manpowerSvcId > 0
    //       ? row.manpowerSvcVal
    //       : "N/A",
    //   sortable: true,
    //   filterable: true,
    // },
    {
      name: "Drivers",
      selector: (row) =>
        !!row?.driver1 && !!row?.driver2
          ? row?.driver1 + "/" + row?.driver2
          : row?.driver1 || row?.driver2,
      sortable: true,
      filterable: true,
    },
    // {
    //   name: "Ton",
    //   selector: (row) => (!!row?.vhclWeight ? row?.vhclWeight : ""),
    //   sortable: true,
    //   filterable: true,
    // },
    {
      name: "Status",
      selector: (row) => row?.statusText,
      cell: (row) => (
        <div
          className={getOrderStatusBadgeClass({
            status: row?.ordStatus,
            shipDateDiffInDays: moment(row?.shipDate).diff(moment(), "days"),
          })}
        >
          {row.statusText}
        </div>
      ),
      sortable: true,
      filterable: true,
    },

    // {
    //   name: "",
    //   cell: (row) => <AddTruckBtn row={row} />,
    //   allowOverflow: true,
    //   button: true,
    //   width: "30px",
    // },
    {
      name: "",
      width: "15px",
      cell: (row) => {
        const condArr = callForConditions(row);
        return (
          <>
            {(condArr[0] || condArr[1]) && (
              <OverlayTrigger
                trigger="click"
                key={row.id}
                placement="left"
                rootClose
                overlay={
                  <Popover id={`popover-positioned-lefft`}>
                    <Popover.Body>
                      <ConditionalBtn row={row} />
                    </Popover.Body>
                  </Popover>
                }
              >
                <span
                  id={`row-action-button-${row?.rowId}`}
                  className="row-action-button"
                >
                  {GetSvgIcon("Trippleverticaldot")}
                </span>
              </OverlayTrigger>
            )}
          </>
        );
      },
    },
  ];

  return (
    <>
      <div className="col-md-12">
        <div className="row">
          <div className="col-auto">
            <label htmlFor="" className="form-label theme-label">
              Trip From
            </label>
            <div>
              <ReactDatePicker
                className="form-control"
                selected={
                  searchParams?.dateFrom
                    ? new Date(searchParams?.dateFrom)
                    : searchParams?.dateFrom
                }
                onChange={(d) => handleChange("dateFrom", d)}
                dateFormat={DATE_FORMAT_CLIENT}
                placeholderText="Select From"
                maxDate={searchParams?.dateTo && new Date(searchParams?.dateTo)}
              />
            </div>
          </div>

          <div className="col-auto">
            <label htmlFor="" className="form-label theme-label">
              Trip To
            </label>
            <div>
              <ReactDatePicker
                className="form-control"
                selected={
                  !!searchParams?.dateTo
                    ? new Date(searchParams?.dateTo)
                    : searchParams?.dateTo
                }
                onChange={(d) => handleChange("dateTo", d)}
                dateFormat={DATE_FORMAT_CLIENT}
                placeholderText="Select To"
                minDate={
                  searchParams?.dateFrom
                    ? new Date(searchParams?.dateFrom)
                    : new Date()
                }
              />
            </div>
          </div>
          <div className="col-md-1">
            <div className="mt-1">
              <label htmlFor="" className="form-label theme-label"></label>
            </div>
            <button
              type="button"
              className="btn btn-outline-secondary theme-violet"
              onClick={onSubmit}
              disabled={
                invalidDataArr.includes(searchParams?.dateFrom) ||
                invalidDataArr.includes(searchParams?.dateTo)
              }
            >
              Search{" "}
            </button>
          </div>
        </div>
      </div>
      <div className="col-md-12 customized-data-table position-relative">
        <DataTable
          columns={columns}
          data={scheduleList}
          pagination
          striped
          highlightOnHover
          paginationRowsPerPageOptions={defaultRowsPerPageOptions}
          paginationPerPage={defaultPageLimit}
          customStyles={customDataTableStyles}
        />
      </div>
    </>
  );
};

export default ScheduleList;
